import { Column, Row, Text } from '@atom-web/micros'
import Slider from 'react-slick'

import getImgIXUrl from '../../../../utils/getImgIXUrl'
import UserAvatar from '../../../packages/components/UserAvatar'
import { SliderWrapper } from '../../../tour-packages/components/image-slider'

const TestimonialSliderSettings = {
	dots: true,
	infinite: true,
	speed: 500,
	fade: true,
	slidesToShow: 1,
	arrows: false,
	autoplay: true,
}

export default ({ data = [] }) => {
	return (
		<SliderWrapper>
			<Slider {...TestimonialSliderSettings}>
				{data.map((testimonial, index) => {
					const travelDate = new Date(testimonial.dateOfDeparture)
					return (
						<Column key={'testimonial' + index}>
							<Text
								css={{
									marginTop: '$1',
									width: '100%',
									fontSize: '15px',
									lineHeight: 1.2,
									letterSpacing: '-0.3px',
									textAlign: 'center',
									color: '#2C2F42',
								}}
							>
								{testimonial.shortestReview}
							</Text>
							<Row
								gap={3}
								css={{
									marginTop: '$4',
									marginBottom: '$4',
								}}
							>
								<UserAvatar
									profileImage={getImgIXUrl(
										testimonial.coverImage,
										'auto=compress&w=40&h=40&fit=facearea&facepad=5',
									)}
									wrapperStyle={{
										'@sm': {
											height: '40px',
											width: '40px',
										},
									}}
								/>
								<Column gap={1}>
									<Text
										css={{
											fontSize: '15px',
											fontWeight: '$bold',
											color: '#333',
											lineHeight: 1.2,
										}}
									>
										{testimonial.fName}
									</Text>
									<Text
										css={{
											fontSize: '15px',
											color: '#AAA',
											lineHeight: 1.2,
										}}
									>
										{travelDate.toLocaleString('en', { month: 'short' })}{' '}
										{travelDate.getFullYear()}. &nbsp;
										{testimonial.type} Trip
									</Text>
								</Column>
							</Row>
						</Column>
					)
				})}
			</Slider>
		</SliderWrapper>
	)
}
